module.exports = __webpack_public_path__ + "static/media/Radio_Button.5c16a227.svg";